<template>
  <div>
    <!-- dialog close visioVente -->
    <v-dialog v-model="dialogCloseVisioVente" persistent max-width="320">
      <!-- dialogueBox messaging -->
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('VisioVente en cours...') }}</v-card-title>
        <v-card-text>
          <p>
          {{ $t('Êtes-vous sûr de vouloir quitter votre visioVente ?') }}
          </p>

          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="closeDialogVisioVente()">{{ $t('no') }}</v-btn>
          <v-btn class="blue--text darken-1" flat @click="stopVisioVente()">{{ $t('yes') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import apiRTC from '@apirtc/apirtc'
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  // props: [
  //   'datasVisiteur'
  // ],
  data () {
    return {
      messageVisioVente: 'Vous pouvez envoyer une invitation à votre internaute afin qu\'il puisse participer à votre visio vente.',
      activeConnexionPeer: false,
      demandeEnvoyee: false,
      localStream: null,
      zoomLocal: true,
      subscribedStreams: {},
      registerInformation: {
        cloudUrl: 'https://cloud.apirtc.com'
      },
      // contactList: {},
      // contactNum: 0,
      // connectedSession: null,
      visioVenteConferenceName: null,
      connectedConversation: null,
      dialogCloseVisioVente: false,
      // ua: null,
      // registerApiRtc: false,
      apzEntrepriseApi: 'cfc58dc8fe7f69260252c7b83cbfc93f'
    }
  },

  computed: {
    ...mapGetters('_User', ['user', 'fullName']),
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),
    ...mapState('_StoreWatcheeBox', ['status', 'sessionVisioVente']),
    /**
     * Vérifie si il y a deja une conf en cours
     */
    checkSessionVisioVente () {
      // si il y a une visio en cours
      if (this.sessionVisioVente.sessionId) {
        // si c'est bien avec ce visiteur
        // if (this.sessionVisioVente.visiteurID === this.datasVisiteur.visiteurID) {
        //   // console.log('bien en conf avec ce visteur', this.$store.state._User.sessionVisioconf.visiteur.visiteurID)
        //   return true
        // }
      } else {
        return false
      }
    },
    infosVisioVente () {
      return this.sessionVisioVente
    },
    // nombre de visionneurs de la visiovente
    // numInternautes () {
    //   return Object.keys(this.contactList).length
    // },
    /**
     * Vérifie si l'agent est en ligne
     */
    agentOnline () {
      if (this.$store.state._StoreWatcheeBox.status === 'online' || this.$store.state._StoreWatcheeBox.status === 'busy') {
        if (!this.$store.state._StoreWatcheeBox.sessionVisioconf.confURL) {
          return true
        }
      }
      return false
    }
  },
  watch: {
    // ----------------------------------------------------------------------------
    // quand un changement dans l'etat du micro
    // ----------------------------------------------------------------------------
    'WATCHEEBOX_STATE.sessionVisioVente.muteMic': function (val, oldVal) {
      console.log('change sessionVisioVente val :', val)
      // console.log('change sessionVisioVente oldVal :', oldVal)
      // if (this.sessionVisioVente.placePupitreVisio === this.datasVisiteur.placePupitre) {
      this.toggleMicVisioVente(val)
      // }
    },
    // ----------------------------------------------------------------------------
    // quand un changement dans l'etat de la caméra
    // ----------------------------------------------------------------------------
    'WATCHEEBOX_STATE.sessionVisioVente.muteCam': function (val, oldVal) {
      console.log('change sessionVisioVente val :', this.sessionVisioVente)
      // console.log('change sessionVisioVente oldVal :', oldVal)
      // if (this.sessionVisioVente.placePupitreVisio === this.datasVisiteur.placePupitre) {
      this.toggleCamVisioVente(val)
      // }
    },
    // ----------------------------------------------------------------------------
    // quand l'agent quitte la visioVente
    // ----------------------------------------------------------------------------
    'WATCHEEBOX_STATE.sessionVisioVente.leaveConf': function (val, oldVal) {
      if (val) {
        // si on est sur la page visiteurs, on coupe direct la visioconf
        if (this.$route.fullPath === '/trafic/visitors') {
          this.stopVisioVente()
        } else {
          this.dialogCloseVisioVente = true
        }
      }
      console.log('change sessionVisioVente val :', val)
      console.log('change sessionVisioVente oldVal :', oldVal)
    },
    // ----------------------------------------------------------------------------
    // quand l'agent quitte la visioVente
    // ----------------------------------------------------------------------------
    'WATCHEEBOX_STATE.sessionVisioVente.startConf': function (val, oldVal) {
      console.log('demarrage de la conf', val)
      if (val) {
        this.startVisioVente()
      }
      // console.log('change sessionVisioVente val :', val)
      // console.log('change sessionVisioVente oldVal :', oldVal)
    },
    // ----------------------------------------------------------------------------
    // quand l'agent inverse les flux vidéos
    // ----------------------------------------------------------------------------
    'WATCHEEBOX_STATE.sessionVisioVente.toggleStream': function (val, oldVal) {
      if (val) {
        this.zoomLocal = true
      } else {
        this.zoomLocal = false
      }
      // if (val) {
      //   this.dialogCloseVisioVente = true
      // }
      // console.log('change toggleStream val :', val)
      // console.log('change toggleStream oldVal :', oldVal)
    }
  },

  created () {},
  mounted () {
    console.log('datavisteur visiovente : ', this.sessionVisioVente)
    // si l'agent est deja en visiconf, il faut le reconnecter
    if (this.infosVisioVente.sessionId) {
      console.log('---> mounted --- this.infosVisioVente.sessionId', this.infosVisioVente.sessionId)
      this.startVisioVente()
      let dataChange = {
        name: 'startConf',
        value: true,
        placePupitreVisio: this.sessionVisioVente.placePupitreVisio,
        visiteurID: this.sessionVisioVente.visiteurID
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_VISIOVENTE', dataChange)
    } else {
      let dataChange = {
        name: 'startConf',
        value: false,
        placePupitreVisio: this.sessionVisioVente.placePupitreVisio,
        visiteurID: this.sessionVisioVente.visiteurID
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_VISIOVENTE', dataChange)
    }
    this.apzEntrepriseApi = this.$store.state._User.apzKey
  },
  beforeDestroy () {
    /* eslint-disable */
    // console.log('beforeDestroy connectedConversation')
    if(typeof this.connectedConversation !== 'undefined') this.stopVisioVente (this.sessionVisioVente.visiteurID)
    /* eslint-enable */
    // this.$store.commit('_StoreWatcheeBox/LEAVE_SESSION_VISIOVENTE')
  },

  methods: {
    // -------------------------------------------
    // création du userAgent apirtc
    // -------------------------------------------
    // createUserAgent () {
    //   console.log('createUserAgent')
    //   if (this.ua) {
    //     this.ua = null
    //   }
    //   this.ua = new apiRTC.UserAgent({
    //     uri: 'apzkey:' + this.apzEntrepriseApi
    //   })

    //   this.ua.register(this.registerInformation)
    //   .then((session) => {
    //     console.log('User registered with session: ', session)
    //     // Save session
    //     this.connectedSession = session
    //     this.registerApiRtc = true
    //   }).catch((err) => {
    //     console.error('User registered error', err)
    //   })
    // },

    // -------------------------------------------
    // demarrer la visiovente
    // -------------------------------------------
    startVisioVente () {
      console.log('start visiovante ', this.sessionVisioVente)
      let dataVisioVente = _.cloneDeep(this.sessionVisioVente)
      this.activeConnexionPeer = true
      // Get conference name
      this.visioVenteConferenceName = 'conf_' + this.sessionVisioVente.visiteurID
      let dataMessage = {
        name: 'message',
        value: {
          text: 'L\'invitation pour participer à votre visio vente à été envoyée à l\'internaute.',
          color: 'info',
          icone: 'info'
        }
      }
      this.sendSysMessageAPZ(dataMessage)
      // ==============================
      // 1/ CREATE USER AGENT
      // ==============================

      // apiRTC.setLogLevel(4)

      let ua = null
      if (this.ua) {
        this.ua = null
      }
      console.log('api')
      console.log(this.apzEntrepriseApi)
      ua = new apiRTC.UserAgent({
        uri: 'apzkey:' + this.apzEntrepriseApi
      })
      // ==============================
      // 2/ REGISTER
      // ==============================
      ua.register(this.registerInformation)
      .then((session) => {
        // Save session
        // this.connectedSession = session
        // this.registerApiRtc = true
        // enregistre dans le store les infos de la session
        dataVisioVente.confName = this.visioVenteConferenceName
        dataVisioVente.sessionId = session.id
        dataVisioVente.placePupitreVisio = this.sessionVisioVente.placePupitreVisio
        dataVisioVente.message = {
          text: 'Création de la visio vente en cours...',
          color: 'info',
          icone: 'info'
        }

        console.log('data dataVisioVente', dataVisioVente)
        // Affiche la liste des utilisateur connectés à la room
        session.on('contactListUpdate', (updatedContacts) => {
          console.log('userAgent session - contactListUpdate', updatedContacts)
          if (this.connectedConversation !== null) {
            // this.contactList = this.connectedConversation.getContacts()
            // this.setNumContact(this.connectedConversation.getContactsNumber())
            // console.info('contactNum', this.contactNum)
          }
        })
        console.log('User registered with session: ', session)

        // ==============================
        // 3/ CREATE CONVERSATION
        // ==============================
        this.connectedConversation = session.getConversation(this.visioVenteConferenceName)

        // ==============================
        // CREATE LOCAL STREAM
        // ==============================
        ua.createStream()
        .then((stream) => {
          // Save local stream
          console.log('stream ua', ua)
          console.log('stream', stream)
          this.localStream = stream
          this.attachLocalStreamVisioVente(stream)
          // ==============================
          // JOIN CONVERSATION
          // ==============================
          this.connectedConversation.join()
          .then((response) => {
            // ==============================
            // PUBLISH OWN STREAM
            // ==============================
            this.connectedConversation.publish(stream)

            this.$store.commit('_StoreWatcheeBox/SET_SESSION_VISIOVENTE', dataVisioVente)
            let dataMessage = {
              name: 'message',
              value: {
                text: 'Vous êtes maintenant bien connecté à votre visio vente',
                color: 'success',
                icone: 'check_circle'
              }
            }
            this.sendSysMessageAPZ(dataMessage)
          }).catch((err) => {
            console.error('Conversation join error', err)
            let dataMessage = {
              name: 'message',
              value: {
                text: err,
                color: 'error',
                icone: 'warning'
              }
            }
            this.sendSysMessageAPZ(dataMessage)
          })
        }).catch((err) => {
          console.error('create stream error', err)
          let dataMessage = {
            name: 'message',
            value: {
              text: err,
              color: 'error',
              icone: 'warning'
            }
          }
          this.sendSysMessageAPZ(dataMessage)
          // il faut efface le userAgent qui vient d'être créé
          this.loading = false
          ua.unregister()
        })

        // ==========================================================
        // WHEN NEW STREAM IS AVAILABLE IN CONVERSATION
        // ==========================================================
        this.connectedConversation.on('availableStreamsUpdated', (streams) => {
          console.log('availableStreamsUpdated', streams)
          var keys = Object.keys(streams)

          for (var i = 0, len = keys.length; i < len; i++) {
            if (typeof this.subscribedStreams[keys[i]] === 'undefined') {
              // ==============================
              // SUBSCRIBE TO STREAM
              // ==============================
              this.subscribedStreams[keys[i]] = streams[keys[i]]
              this.connectedConversation.subscribeToMedia(keys[i])
            }
          }
        })

        // ==========================================================
        // WHEN NEW STREAM IS ADDED TO CONVERSATION
        // ==========================================================
        this.connectedConversation.on('streamAdded', (stream) => {
          // Attach stream
          // stream.attachToElement(mediaElement)
          console.log('streamAdded', stream)
          // console.log('num contact', this.connectedConversation.getContactsNumber())
          console.log('stream type', stream.getType())
          console.log('stream settings', stream.getSettings())
        })

        // =====================================================
        // WHEN STREAM WAS REMOVED FROM THE CONVERSATION
        // =====================================================
        this.connectedConversation.on('streamRemoved', (streamInfos) => {
          console.log('streamRemoved')
          console.log(streamInfos)
          this.removeRemoteStreamVisioVente()
        })

        this.connectedConversation.on('contactJoined', (event) => {
          console.log('contactJoined', event)
          this.setNumContact(this.connectedConversation.getContactsNumber())
          // this.contactNum = this.connectedConversation.getContactsNumber()
        })

        this.connectedConversation.on('contactLeft', (event) => {
          console.log('contactLeft', event)
          this.setNumContact(this.connectedConversation.getContactsNumber())
          // this.contactNum = this.connectedConversation.getContactsNumber()
          // this.stopVisioVente(this.datasVisiteur.visiteurID)
        })

        this.connectedConversation.on('joined', (event) => {
          console.log('joined', event)
        })

        this.connectedConversation.on('left', (event) => {
          console.log('userAgent left', event)
          ua.unregister()
          .then(() => {
            // OK : UserAgent is disconnected from the ApiRTC platform
            ua = null
            console.log('UA effacé', ua)
          })
          .catch((error) => {
            // error : an error occured during unregistration
            console.log('erreur durant le processus de suppression du userAgent', error)
          })
        })

        this.connectedConversation.on('localStreamUpdated', (event) => {
          console.log('localStreamUpdated', event)
        })

        this.connectedConversation.on('streamListChanged', (streamInfo) => {
          console.log('streamListChanged', streamInfo)
          if (streamInfo.listEventType === 'added') {
            // c'est bien le remoteStream
            if (streamInfo.isRemote) {
              this.connectedConversation.subscribeToMedia(streamInfo.streamId)
              .then((stream) => {
                console.log('subscribeToMedia success', stream)
                this.attachRemoteStreamVisioVente(stream)
              }).catch((err) => {
                console.error('subscribeToMedia error', err)
              })
            }
          }
        })
      }).catch((err) => {
        console.error('User registered error', err)
        let dataMessage = {
          name: 'message',
          value: {
            text: err,
            color: 'error',
            icone: 'warning'
          }
        }
        this.sendSysMessageAPZ(dataMessage)
      })
    },

    // -------------------------------------------
    // arreter la visiovente
    // -------------------------------------------
    stopVisioVente (sessionId) {
      console.log('stopVisioVente', sessionId)
      // Leave Conversation
      if (this.connectedConversation !== null) {
        // Leaving actual conversation
        this.connectedConversation.leave()
        .then(() => {
          console.debug('Conversation leave OK')
          this.connectedConversation.destroy()
          this.connectedConversation = null
          this.localStream.release()
        }).catch((err) => {
          console.error('Conversation leave error', err)
        })
      }
      // this.registerApiRtc = false
      // Leave Conversation
      // if (this.connectedConversation !== null) {
      // this.$store.commit('_StoreWatcheeBox/RELEASE_LOCALSTREAM_VISIOVENTE')
      // Leaving actual conversation
      // this.$store.commit('_StoreWatcheeBox/LEAVE_SESSION_VISIOVENTE')
      // this.$store.commit('_StoreWatcheeBox/DESTROY_SESSION_VISIOVENTE')
      // efface du store les infos visioVente
      this.$store.commit('_StoreWatcheeBox/DEL_SESSION_VISIOVENTE')
      // this.effaceUA() // afface le userAgent
      // ferme la dialogBox
      this.dialogCloseVisioVente = false
    },

    // -------------------------------------------
    // arreter/marche de la caméra
    // -------------------------------------------
    toggleCamVisioVente (val) {
      console.log('toggleCamVisioVente', val)
      console.log('store localStream', this.localStream)
      if (val && val !== 'undefined') {
        this.localStream.muteVideo()
      } else {
        this.localStream.unmuteVideo()
      }
    },
    // -------------------------------------------
    // arreter/marche du micro
    // -------------------------------------------
    toggleMicVisioVente (val) {
      console.log('toggleMicVisioVente', val)
      if (val) {
        this.localStream.muteAudio()
      } else {
        this.localStream.unmuteAudio()
      }
    },
    openDialogVisioVente () {
      // this.dialogCloseVisioVente = true
    },
    closeDialogVisioVente () {
      let dataChange = {
        name: 'leaveConf',
        value: false,
        placePupitreVisio: this.sessionVisioVente.placePupitreVisio,
        visiteurID: this.sessionVisioVente.visiteurID
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_VISIOVENTE', dataChange)
      this.dialogCloseVisioVente = false
    },

    // ----------------------------------------------------------------------------
    // send messages systeme visioconf
    // ----------------------------------------------------------------------------
    sendSysMessageAPZ (data) {
      console.log('sendSysMessageAPZ', data)
      this.$store.commit('_StoreWatcheeBox/MESSAGES_SYSTEM_VISIOVENTE', data)
    },

    // ----------------------------------------------------------------------------
    // active/desactive le micro
    // ----------------------------------------------------------------------------
    setNumContact (num) {
      let dataChange = {
        name: 'numContacts',
        value: num,
        placePupitreVisio: this.sessionVisioVente.placePupitreVisio,
        visiteurID: this.sessionVisioVente.visiteurID
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_VISIOVENTE', dataChange)
    },

    // --------------------------------------------------------
    // attache le local stream dans le bon element
    // --------------------------------------------------------
    attachLocalStreamVisioVente (stream) {
      // Attache stream
      console.log('tf_localVideo_' + this.sessionVisioVente.placePupitreVisio)
      // let conteneurVIsioLocal = document.getElementById('tf_local-media')
      stream.removeFromDiv('tf_localVideo_' + this.sessionVisioVente.placePupitreVisio, 'tf_local-media')
      stream.addInDiv('tf_localVideo_' + this.sessionVisioVente.placePupitreVisio, 'tf_local-media', {}, true)
      // stream.attachToElement(conteneurVIsioLocal)

      // si sur mobile, il faut afficher le chat pour voir la vidéo
      this.$emit('cacheInfosVisiteur')
    },
    removeLocalStreamVisioVente (stream) {
      console.log('remove local stream')
      // remove stream
      stream.removeFromDiv('tf_localVideo_' + this.sessionVisioVente.placePupitreVisio, 'tf_local-media')
    },

    // --------------------------------------------------------
    // attache le remote stream dans le bon element
    // --------------------------------------------------------
    attachRemoteStreamVisioVente (stream) {
      console.log('attache remote stream ', this.sessionVisioVente)
      // Attache stream
      stream.removeFromDiv('tf_remoteVideo_' + this.sessionVisioVente.placePupitreVisio, 'tf_remote-media')
      stream.addInDiv('tf_remoteVideo_' + this.sessionVisioVente.placePupitreVisio, 'tf_remote-media', {}, false)
      // let conteneurVIsioRemote = document.getElementById('tf_remote-media')
      // stream.attachToElement(conteneurVIsioRemote)
      // si sur mobile, il faut afficher le chat pour voir la vidéo
      // this.$emit('cacheInfosVisiteur')
      let dataChange = {
        name: 'remoteStream',
        value: true,
        placePupitreVisio: this.sessionVisioVente.placePupitreVisio,
        visiteurID: this.sessionVisioVente.visiteurID
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_VISIOVENTE', dataChange)
    },
    removeRemoteStreamVisioVente (stream) {
      console.log('remove remote stream')
      // remove stream
      // stream.removeFromDiv('tf_remoteVideo_', 'tf_remote-media')
      let dataChange = {
        name: 'remoteStream',
        value: false,
        placePupitreVisio: this.sessionVisioVente.placePupitreVisio,
        visiteurID: this.sessionVisioVente.visiteurID
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_VISIOVENTE', dataChange)
    }
  }
}
</script>

<style>
/*--------------------*/
/* --- visio vente ---*/
.visioConfOFF .tf_visioVente {
  display: none;
}
.visioConfON .tf_visioVente {
  display: block;
}
.tf_menuVisio {
  display: inline;
  right: 0px;
  position: absolute;
  z-index: 5;
  width: 100%;
}
.tf_menuVisio .visioVente_num_visiteur {
  margin-top: 10px;
  float: left;
}
.tf_menuVisio .visioVente_muteMic,
.tf_menuVisio .visioVente_muteCam{
  float: right;
}
.tf_visioVente {
  z-index: 1;
  position: absolute;
  top: 48px;
  width: 100%;
  height: calc(100% - 48px);
  background-color: black;
  overflow: hidden;
}
/*--- locale stream zoomer ---*/
.tf_localVideo.zoomStream {
  width: 50%;
  right: 0px;
  z-index: 3;
  top: 0px;
  /* position: absolute; */
  transform: rotateY(180deg);
  -webkit-transform:rotateY(180deg); /* Safari and Chrome */
  -moz-transform:rotateY(180deg); /* Firefox */
}
.divisHauteur .zoomStream #tf_local-media {
  height: calc(100vh - 480px) !important;
  width: auto !important;
  transform: translateX(-50%);
}
.zoomStream #tf_local-media {
  height: calc(100vh - 152px) !important;
  width: auto !important;
  transform: translateX(-50%);
}
/*--- remote stream ---*/
.tf_localVideo {
  position: absolute;
  z-index: 5;
  top: 58px;
  left: 8px;
  width: 50px;
}
#tf_local-media {
  width: 50px;
  border-radius: 4px;
}
.zoomStream #tf_local-media {
  border-radius: 0px;
}


/*--- remote stream zoomer ---*/
.tf_remoteVideo.zoomStream {
  position: relative;
  z-index: 3;
  top: 0px;
  width: 50%;
  right: 0px;
  float: right;
}
.divisHauteur .zoomStream #tf_remote-media {
  height: calc(100vh - 480px) !important;
  width: auto !important;
  transform: translateX(-50%);
}

.zoomStream #tf_remote-media {
  height: calc(100vh - 152px) !important;
  width: auto !important;
  transform: translateX(-50%);
  left: 0px;
}

/* .fullWidthChat{

} */

/*--- remote stream ---*/
.tf_remoteVideo {
  position: absolute;
  z-index: 5;
  top: 58px;
  left: 8px;
  width: 50px;
}
#tf_remote-media {
  width: 50px;
  border-radius: 4px;
}

.actionUnzoomVideo {
    position: absolute;
    z-index: 10;
    top: 58px;
    left: 8px;
    width: 52px;
    height: 45px;
    cursor: pointer;
}

.visioConfON .conteneur-WatchBox-MessageWrapper{
  background-color: rgba(256, 256, 256, 0.85);
}
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzModuleVisioAPZ.vue